import {  clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import type {ClassValue} from "clsx";

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs))
}

// Função para normalizar texto para slug (permite traços no início/fim durante digitação)
export function normalizeToSlug(text: string, allowLeadingTrailing = true): string {
  if (!text) return ''

  // Remove acentos
  const withoutAccents = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

  // Troca espaços por traços
  let slug = withoutAccents.replace(/\s+/g, '-')

  // Remove caracteres especiais, mantém apenas letras, números e traços
  slug = slug.replace(/[^a-z0-9-]/g, '')

  // Remove traços múltiplos consecutivos
  slug = slug.replace(/-+/g, '-')

  // Remove traços no início e fim apenas se não estiver digitando
  if (!allowLeadingTrailing) {
    slug = slug.replace(/^-+|-+$/g, '')
  }

  return slug
}
